import useUpdateCover from '@/hooks/profile/business/useUpdateCover';
import { DEFAULT_GROUP_COVER } from '../../../../../../constant/imgImport';
import Cover from '../../../../../image/Cover';

const EnterpriseCover = ({
  cover,
  canEdit,
}: {
  cover: string | null;
  canEdit: boolean;
}) => {
  const {
    mutateReturn: { mutateAsync },
  } = useUpdateCover();

  return (
    <>
      <Cover
        value={cover || DEFAULT_GROUP_COVER}
        onChange={mutateAsync}
        canEdit={canEdit}
        bottomClassname={'w-full'}
      />
    </>
  );
};

export default EnterpriseCover;
